import { render, staticRenderFns } from "./HeaderAdmin.vue?vue&type=template&id=3c6be50f&"
import script from "./HeaderAdmin.vue?vue&type=script&lang=js&"
export * from "./HeaderAdmin.vue?vue&type=script&lang=js&"
import style0 from "./HeaderAdmin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports